import { defineStore } from 'pinia'
import { getCategory, getSubCategoryByCategory } from '@/services/categoryService'
import { getGeneral } from '@/services/generalService'

export const useGeneralStore = defineStore('general', {
  state: () => ({
    categories: [],
    generals: {},
    downloadUrl: {},
    downloadFileName: {},
    loading: false,
    error: null
  }),

  actions: {
    async fetchGeneral() {
      this.loading = true
      this.error = null

      try {
        const baseUploadURL = process.env.VUE_APP_API_URL;
        const categoryList = await getCategory()
        const generalContent = await getGeneral()
        generalContent.thumbnail = generalContent.banner ? baseUploadURL + generalContent.banner.uploadFile : null
        this.downloadUrl = generalContent.companyProfile ? baseUploadURL + generalContent.companyProfile.uploadFile : null
        this.downloadFileName = generalContent.companyProfile ? generalContent.companyProfile.filename : null

        const mapCategoryList = await Promise.all(
          categoryList.map(async item => ({
            ...item,
            subCategories: await getSubCategoryByCategory(item.id)
          }))
        )
        this.categories = mapCategoryList
        this.generals = generalContent

        // console.log(this.generals)
        // console.log(this.downloadUrl)
        // console.log(this.categories)
      } catch (err) {
        this.error = err.message
      } finally {
        this.loading = false
      }
    }
  }
})